const convertClassificationToDropdownOptions = opts => opts && opts.map(({ id, name }) => ({
    key: id,
    value: name,
}));

export default convertClassificationToDropdownOptions;
